export default "__VITE_ASSET__B_5XS_RL__"